import { render } from "./BodyFooter.vue?vue&type=template&id=2264bc38&scoped=true"
import script from "./BodyFooter.vue?vue&type=script&lang=js"
export * from "./BodyFooter.vue?vue&type=script&lang=js"

import "./BodyFooter.vue?vue&type=style&index=0&id=2264bc38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2264bc38"]])

export default __exports__